import React, { Component } from "react"
import axios from "axios"
import { Button, FormControl, Modal, Spinner } from "react-bootstrap"
import snackBar from "../../../../../../../../../utilities/snackBar/SnackBar"
import AxiosConfig from "../../../../../../../../../utilities/AxiosConfig"
import IncidentAppointmentTypes from "../../../../../../../Types/IncidentAppointmentTypes"
import incidentAppointmentParams from "../IncidentAppointmentParams"
import DatePicker from "../../../../../../../../../components/common/DatePicker"
import moment from "moment"
import "./AddIncidentAppointment.css"

interface Props {
    toggleAddAppointment: Function
    addAppointment: Function
    IncidentId: number
    timeFormat: string
    userId: string | number
}

interface State {
    appointment: IncidentAppointmentTypes | {}
    copy: IncidentAppointmentTypes | {}
    saving: boolean
    eventType: string
    isDirty: boolean
    confirmDiscard: boolean
}

class AddIncidentAppointment extends Component<Props, State> {

    state = {
        appointment: incidentAppointmentParams,
        copy: incidentAppointmentParams,
        saving: false,
        eventType: "",
        isDirty: false,
        confirmDiscard: false
    }
    setEventType = (s: string) => {
        this.setState({ eventType: s })
    }

    componentDidMount() {
        for (const [key] of Object.entries(incidentAppointmentParams)) {
            incidentAppointmentParams[key] = null
        }
        this.setState({ appointment: JSON.parse(JSON.stringify(incidentAppointmentParams)), copy: JSON.parse(JSON.stringify(incidentAppointmentParams)) })
    }

    handleChange = (event: { target: { value: string } }) => {
        let input = event.target.value
        let appointment = this.state.appointment
        let eventType = this.state.eventType
        let eventTypes = Object.keys(appointment)
        let temp: any = appointment
        for (let i = 0; i < eventTypes.length; i++) {
            if (eventType === eventTypes[i]) {
                temp[eventTypes[i]] = input
                let param: object = { [eventTypes[i]]: input }
                this.appendParams([param])
            }
        }
    }

    appendParams = (params: Array<object>) => {
        const self = this
        for (let i = 0; i < params.length; i++) {
            let key = Object.keys(params[i])
            let value = Object.values(params[i])
            if (value[0] !== "") {
                incidentAppointmentParams[key[0]] = value[0]
            } else {
                incidentAppointmentParams[key[0]] = null
            }
        }
        this.setState({ appointment: incidentAppointmentParams })
        setTimeout(() => {
            self.submitCheck()
        }, 500)
    }

    submitCheck = () => {
        if (JSON.stringify(this.state.appointment) !== JSON.stringify(this.state.copy)) {
            this.setState({ isDirty: true })
        } else {
            this.setState({ isDirty: false })
        }
    }

    save = (rb: IncidentAppointmentTypes) => {
        this.setState({ saving: true })
        rb.CreatedDateUTC = moment(Date.now()).format()
        rb.CreatedBy = this.props.userId
        rb.IncidentId = this.props.IncidentId
        axios.post(process.env.REACT_APP_API_URL + "/api/workComp/addOrUpdateIncidentMedicalAppointmentPost", rb, AxiosConfig.configValue("min"))
            .then(res => {
                this.setState({ saving: false })
                snackBar({ text: "Appointments updated", type: "success", timeout: 4000 })
                this.props.addAppointment(rb)
            })
            .catch(err => {
                //console.log(err)
                this.setState({ saving: false })
                snackBar({ text: "Failed to add or update appointment(s)", type: "error", timeout: 4000 })
            })
    }

    back = () => {
        if (!this.state.isDirty) {
            this.props.toggleAddAppointment()
        } else {
            this.setState({ confirmDiscard: true })
        }
    }

    shouldDiscard = (discard: boolean) => {
        if (discard) {
            this.props.toggleAddAppointment()
        } else {
            this.setState({ confirmDiscard: false })
        }
    }

    render() {

        // //console.log("Appointment Props: ", this.props)
        // //console.log("Appointment State: ", this.state)
        // //console.log("Appointment Params: ", appointmentParams)
        // //console.log("Dirty?: " + this.state.isDirty)

        return (
            <div className="AddIncidentAppointment">
                {!this.state.confirmDiscard && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="AddIncidentAppointmentHeader">
                            <p>Add Appointment</p>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="AddIncidentAppointmentBody">
                            <div className="IncidentAppontmentDatePickerWrapper">
                                <p>Date</p>
                                <DatePicker value={this.state.appointment.AppointmentDateUTC || ""} onChange={(val: number) => this.appendParams([{ AppointmentDateUTC: moment(val.valueOf()).format(this.props.timeFormat) }])} type="input" useCloseCallback />
                            </div>
                            <FormControl onFocus={() => this.setEventType("AppointmentDesc")}
                                as="textarea"
                                rows={4}
                                placeholder={"Description"}
                                aria-describedby="basic-addon1"
                                onChange={this.handleChange}
                                value={this.state.appointment.AppointmentDesc || ""}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="AddIncidentAppointmentFooter">
                            {!this.state.saving && <Button id="add-incident-appointment-save-back-btn" variant="secondary" onClick={() => this.back()}>Cancel</Button>}
                            {this.state.appointment.AppointmentDesc && this.state.appointment.AppointmentDateUTC && !this.state.saving && <Button id="add-incident-appointment-save-btn" variant="primary" onClick={() => this.save(incidentAppointmentParams)} >Save</Button>}
                            {this.state.saving && <Spinner id="add-incident-appointment-saving-spinner" animation="border" />}
                        </div>
                    </Modal.Footer>
                </Modal>}
                {this.state.confirmDiscard && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="IncidentDiscardModalHeader">
                            <p>Are you sure you want to quit? Any unsaved changes will be lost.</p>
                        </div>
                    </Modal.Header>
                    <Modal.Footer>
                        <div className="AddIncidentAppointmentDiscardModalFooter">
                            <Button id="add-incident-appointment-discard-btn-dicard" variant="danger" onClick={() => this.shouldDiscard(true)}>Quit</Button>
                            <Button id="add-incident-appointment-discard-back-btn" variant="secondary" onClick={() => this.shouldDiscard(false)} >Back</Button>
                        </div>
                    </Modal.Footer>
                </Modal>}
            </div>
        )
    }
}

export default AddIncidentAppointment